<template>
  <div id="app">
    <router-view name="header"></router-view>
    <notifications group="notification_01" classes="vue-notification text-dark" :reverse="true"/>
    <router-view/>
    <router-view name="footer"></router-view>
  </div>
</template>

<script>

export default {
  name: 'app',
  components: {
  }
}
</script>

<style>
#app {
  /* font-family: 'Avenir', Helvetica, Arial, sans-serif; */
  font-family: Segoe UI,Frutiger,Frutiger Linotype,Dejavu Sans,Helvetica Neue,Arial,sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100vh!important;
  /* background-image: url("/img/background3.jpg"); */
  /* background-image: url("/img/IRSPLandingBG2.png"); */
  /* background-image: url("/img/IRSPLandingBG2.png"); */
  /* background-image: url("/img/GWH_BG.jpg"); */
  /* background-image: url("/img/nsw-ports.jpg"); */
  /* background-image: url("/img/nswportBG6.png"); */
  background-image: url("/img/portBotanyBG3.png");
  /* background-image: url("/img/GWH_BG.jpg"); */
  /* background-size: cover; */
  /* background-size: 100vw 94.5vh; */
  background-size: 100vw 100vh;
  background-repeat: no-repeat;
  overflow:hidden;
}
</style>
